(function () {
  var THRESHOLD = 40;

  function init() {
    document.querySelectorAll('slider-component.product-media-slider').forEach(function (slider) {
      if (slider.dataset.swipeInit === '1') return;
      slider.dataset.swipeInit = '1';

      var list = slider.querySelector('.product__media-list');
      if (!list) return;

      var startX = 0, startY = 0, moved = false;

      list.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        moved = false;
      }, { passive: true });

      list.addEventListener('touchmove', function () {
        moved = true;
      }, { passive: true });

      list.addEventListener('touchend', function (e) {
        if (!moved) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        if (Math.abs(dx) < THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;
        var btn = slider.querySelector(dx < 0 ? 'button[name="next"]' : 'button[name="previous"]');
        if (btn && !btn.disabled) btn.click();
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
